const DEFAULT_TITLE = "Trusted Leap | Independent Professional Services Network";

export const Seo = ({ title, description, path = "", type = "website", jsonLd, noindex = false }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} | Trusted Leap` : DEFAULT_TITLE;
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Trusted Leap" />
      <meta property="og:image" content={`${origin}/images/hero.jpg`} />
      <meta name="twitter:card" content="summary_large_image" />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {jsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}
    </>
  );
};
